import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../css/keyword.scss";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import HistoryIcon from "@mui/icons-material/History";
import searchArrow from "../../Assets/keyword/search-arrow.svg";
import { FiDownload } from "react-icons/fi";

import { DottLoader } from "../../share/loader";
import { domainRegex, handleInvitedUserAccess } from "../../../helperJs/helper";
import LoadingButton from "../../share/components/LoadingButton";

import Input from "@semcore/ui/input";
import ArrowRightM from "@semcore/ui/icon/ArrowRight/m";
import RecentM from "@semcore/ui/icon/Recent/m";

import {
  KEYWORD_GET,
  KEYWORD_VIEW_LIMIT_UPDATE,
  KEYWORD_VIEW_LIMIT_get,
  POST_KEYWORD,
  POST_KEYWORD_VIEW_LIMIT,
  GET_AI_BASED_KEYWORD,
  POST_AI_BASED_KEYWORD,
  POST_KEYWORD_IDEAS,
  GET_KEYWORD_IDEAS,
} from "../../../services/constants";

import { ZustandStore } from "../../../store/zustand-store";
import CountryBasedOnLanuage from "../../share/components/CountryBasedOnLanuage";
import { handleSaveHistory } from ".././Search-History/searchOperations";
import useQuery from "../../share/custom-hook/useQuery";
import Tooltip from "../../share/components/tooltip";
import html2canvas from "html2canvas";
import { useTranslation } from "react-i18next";
import SemButton from "../../../common/components/Button";

const KeywordDataProvider = ({ children, title }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const admin_mail = localStorage.getItem("admin_mail");
  const keywordviewlimit = useSelector((state) => state.keywordviewlimit);

  const { userAccessData, keyword_research_data, country_Language_Data } =
    ZustandStore((state) => state);

  const { setQueryParams, removeQueryParams } = useQuery();

  const [keywordName, setKeywordName] = useState("");
  const [loading, setLoading] = useState(false);
  const [valAlert, setValAlert] = useState(false);
  const [domainLocation, setDomainLocation] = useState({
    location_name: "United States",
    location_code: 2840,
    location_flag: "https://flagsapi.com/US/flat/24.png",
    language_code: "en",
    language_name: "English",
  });
  const [pdfLoader, setPdfLoader] = useState(false);
  const page_data = userAccessData?.[0]?.access;
  const isPageAccess = handleInvitedUserAccess("keywordresearch", page_data);

  const fatch_keyLIMIT = async () => {
    try {
      const res = await axios.get(KEYWORD_VIEW_LIMIT_get(admin_mail));
      return res.data;
    } catch (error) {
      return [];
    }
  };

  const handleAddQuery = () => {
    setQueryParams({
      keyword: keywordName,
      language: domainLocation?.language_name,
      country: domainLocation?.location_name,
    });
  };

  const handleRemoveQuery = () => {
    removeQueryParams(["country", "language", "keyword"]);
  };

  useEffect(() => {
    if (keywordName === "") {
      handleRemoveQuery();
    } else {
      handleAddQuery();
    }
  }, [keywordName]);

  const getSessionStorageItem = (key, parseJson = false) => {
    const item = sessionStorage.getItem(key);
    return parseJson && item ? JSON.parse(item) : item;
  };

  const handleQuesBasedKeywordApi = async (item) => {
    try {
      const response = await axios.get(GET_AI_BASED_KEYWORD(item));

      if (response?.data?.length > 0) {
        return ZustandStore.setState({
          keyword_ques_based_data: {
            data: response.data,
            loading: false,
            search: true,
          },
        });
      }

      // If no data, make a POST request
      const postResponse = await axios.post(POST_AI_BASED_KEYWORD(item));

      ZustandStore.setState({
        keyword_ques_based_data: {
          data: postResponse.data || [],
          loading: false,
          search: true,
        },
      });
    } catch (error) {
      ZustandStore.setState({
        keyword_ques_based_data: {
          data: [],
          loading: false,
          search: false,
        },
      });
    }
  };

  const updateKeywordResearchState = (data) => {
    const items = data?.[0]?.items ?? [];
    ZustandStore.setState({
      keyword_research_ideas_data: {
        data: items.length > 0 ? items : [],
        loading: false,
        search: true,
      },
    });
  };

  const handleKeywordIdeas = async (item) => {
    try {
      const res = await axios.get(GET_KEYWORD_IDEAS(item));

      if (res?.data?.length > 0) {
        return updateKeywordResearchState(res.data);
      }

      // If no data, make a POST request
      const postRes = await axios.post(POST_KEYWORD_IDEAS(item));
      updateKeywordResearchState(postRes.data);
    } catch (error) {
      ZustandStore.setState({
        keyword_research_ideas_data: {
          data: [],
          loading: false,
          search: false,
        },
      });
    }
  };

  const updateKeywordState = (data) => {
    const items = data?.[0]?.items ?? [];

    if (items.length === 0) {
      ZustandStore.setState({
        keyword_research_data: {
          data: [],
          loading: false,
          search: true,
          error: "Sorry, don't have any data for this keyword",
        },
      });
    } else {
      ZustandStore.setState({
        keyword_research_data: {
          data: data?.[0],
          loading: false,
          search: true,
          error: false,
        },
      });
    }
    setLoading(false);
  };

  // keyword get data
  const handleOldWayKeywordGet = async (keyword) => {
    if (keyword === "") {
      setValAlert(t("keyword_research.alert_valid_keyword"));
      return;
    }

    if (domainLocation?.location_name === "No Country") {
      setValAlert(t("keyword_research.no_country"));
      return;
    }
    if (keywordviewlimit === 0) {
      setValAlert(t("keyword_research.no_plan"));
      return;
    }

    const keywordviewLength = await fatch_keyLIMIT();
    if (
      keywordviewLength?.[0]?.keywordlmt >= keywordviewlimit &&
      keywordviewLength?.length !== 0
    ) {
      setValAlert(t("competitive_research.alert_msg.increase_limit"));
    } else {
      setLoading(true);
      if (keywordviewLength.length === 0) {
        const postIntem = {
          email: admin_mail,
          keywordlmt: 1,
        };
        axios.post(POST_KEYWORD_VIEW_LIMIT(), postIntem).then(() => {
          fatch_keyLIMIT();
        });
      } else {
        const postIntem = {
          email: admin_mail,
          keywordlmt: keywordviewLength[0]?.keywordlmt + 1,
        };
        axios
          .put(KEYWORD_VIEW_LIMIT_UPDATE(keywordviewLength[0]?.id), postIntem)
          .then(() => {
            fatch_keyLIMIT();
          });
      }

      const item = {
        locationcode: domainLocation?.location_code,
        keyword: keyword,
        language_code: domainLocation?.language_code,
      };

      // Fetch related keyword data
      handleQuesBasedKeywordApi(item);
      handleKeywordIdeas(item);

      axios
        .get(KEYWORD_GET(item))
        .then((res) => {
          if (res.data.length > 0) {
            updateKeywordState(res.data);
          } else {
            axios
              .post(POST_KEYWORD(item))
              .then((res) => {
                updateKeywordState(res.data);
              })
              .catch(() => {
                ZustandStore.setState({
                  keyword_research_data: {
                    data: [],
                    loading: false,
                    search: false,
                    error: "Sorry, don't have any data for this keyword",
                  },
                });
                setLoading(false);
              });
          }
        })
        .catch(() => {
          ZustandStore.setState({
            keyword_research_data: {
              data: [],
              loading: false,
              search: false,
              error: "Sorry, don't have any data for this keyword",
            },
          });
          setLoading(false);
        });
    }
  };

  const domainName = getSessionStorageItem("KEYWORD_DOMAIN_NAME");
  const onRefreshCall = () => {
    const country = getSessionStorageItem("KEYWORD_DOMAIN_COUNTRY", true);
    const isSearch = getSessionStorageItem("KEYWORD_DOMAIN_SEARCH");

    if (!isPageAccess) {
      sessionStorage.removeItem("KEYWORD_DOMAIN_NAME");
      sessionStorage.removeItem("KEYWORD_DOMAIN_COUNTRY");
      setKeywordName("");
      setDomainLocation({
        location_name: "United States",
        location_code: 2840,
        location_flag: "https://flagsapi.com/US/flat/24.png",
        language_code: "en",
        language_name: "English",
      });
      return;
    }

    if (domainName) {
      setKeywordName(domainName);
      if (isSearch) {
        sessionStorage.removeItem("KEYWORD_DOMAIN_SEARCH");
        handleOldWayKeywordGet(domainName);
      }
    }

    if (country) {
      setDomainLocation({
        location_name: country?.location_name,
        location_code: country?.location_code,
        location_flag: country?.location_flag,
        language_code: country?.language_code,
        language_name: country?.language_name,
      });
    }
  };

  useEffect(() => {
    onRefreshCall();
  }, [isPageAccess, domainName]);

  // submit handler
  const keywordSearchHand = (e) => {
    if (!isPageAccess) return;
    e.preventDefault();

    ZustandStore.setState({
      history_data: {
        data: [],
        error: false,
        loading: false,
      },
      keyword_research_data: {
        data: [],
        loading: false,
        search: false,
        error: false,
      },
      keyword_research_ideas_data: {
        data: [],
        loading: false,
        search: false,
      },
      keyword_ques_based_data: {
        data: [],
        loading: false,
        search: false,
      },
    });

    if (keywordName === "") {
      setValAlert(t("keyword_research.alert_enter_keyword"));
      return;
    } else if (domainRegex.test(keywordName)) {
      setValAlert(t("keyword_research.alert_valid_keyword"));
      return;
    }

    const sel_country = {
      location_name: domainLocation?.location_name,
      location_code: domainLocation?.location_code,
      location_flag: domainLocation?.location_flag,
      language_code: domainLocation?.language_code,
      language_name: domainLocation?.language_name,
    };

    const config = {
      domain: keywordName,
      type: "keyword",
      location: sel_country,
    };
    sessionStorage.setItem(
      "KEYWORD_DOMAIN_COUNTRY",
      JSON.stringify(sel_country)
    );
    sessionStorage.setItem("KEYWORD_DOMAIN_NAME", keywordName);
    ZustandStore.setState({
      history_data: {
        data: [],
        error: false,
        loading: true,
      },
      keyword_research_data: {
        data: [],
        loading: true,
        search: true,
        error: false,
      },
      keyword_research_ideas_data: {
        data: [],
        loading: true,
        search: true,
      },
      keyword_ques_based_data: {
        data: [],
        loading: true,
        search: true,
      },
    });
    handleOldWayKeywordGet(keywordName);
    handleSaveHistory(config);
  };

  const countryDetailHandler = (e) => {
    setDomainLocation({
      location_name: e?.location_name,
      location_code: e?.location_code,
      location_flag: e?.flag,
      language_code: e?.language_code,
      language_name: e?.language_name,
    });
  };

  const handlePdfDownload = () => {
    const element = document.getElementById("keyresearch");
    const comp = document.getElementById("competit-lvl");
    if (element) {
      setPdfLoader(true);
      // Store original styles
      const originalBgColor = element.style.backgroundColor;
      const originalMarginTop = element.style.marginTop;
      const originalMarginBottom = element.style.marginBottom;

      // if (comp) {
      //   comp.style.display = "none";
      // }

      // Apply new styles
      element.style.backgroundColor = "#ffffff";
      element.style.marginTop = "10px";
      element.style.marginBottom = "10px";

      html2canvas(element, {
        logging: false,
        useCORS: true,
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg");
          sessionStorage.setItem("dashboardImage", imgData);
          sessionStorage.setItem(
            "pdfSessionData",
            JSON.stringify({ keywordName: keywordName, id: 10 })
          );
          navigate("/CrawledPageEditor");
        })
        .catch((error) => {
          console.error("Error capturing the dashboard as an image:", error);
        })
        .finally(() => {
          // Restore original styles after capturing
          element.style.backgroundColor = originalBgColor;
          element.style.marginTop = originalMarginTop;
          element.style.marginBottom = originalMarginBottom;
          setPdfLoader(false);
        });
    }
  };

  const tooltip_text = {
    [t("keyword_research.keyword_variations.title")]: t(
      "keyword_research.keyword_variations.tooltip"
    ),
    [t("keyword_research.keyword_ideas.title")]: t(
      "keyword_research.keyword_ideas.tooltip"
    ),
  };

  return (
    <main className="keyword-research-container main-pd">
      <div className="keyword-research-form keyword2">
        <div className="w-100">
          <h5 className="">
            {title}
            {title === t("keyword_research.keyword_overview.title") ? null : (
              <Tooltip title={tooltip_text[title]} />
            )}
          </h5>
          <p className="keyword-p">
            {t("keyword_research.keyword_overview.discription")}
          </p>
          <form
            onSubmit={(e) => {
              keywordSearchHand(e);
            }}
          >
            <div className="overview-search-contain">
              <div className="keyword-input font-regular heading-small">
                <Input w={"100%"} h={"35px"}>
                  <Input.Value
                    type={"text"}
                    placeholder={t(
                      "keyword_research.keyword_overview.form.placeholder"
                    )}
                    value={keywordName}
                    onChange={(value) => {
                      sessionStorage.removeItem("KEYWORD_DOMAIN_NAME");
                      setKeywordName(value);
                      valAlert && setValAlert(false);
                    }}
                  />
                </Input>
              </div>

              <CountryBasedOnLanuage
                data={country_Language_Data}
                img={domainLocation?.location_flag}
                title={`${domainLocation?.language_name} / ${domainLocation?.location_name}`}
                callback={countryDetailHandler}
              />

              <SemButton
                name={t("common_buttons.search")}
                title={t("common_buttons.search")}
                disabled={!isPageAccess}
                onClick={(e) => keywordSearchHand(e)}
                icon={<ArrowRightM />}
              />

              <Link to={"/activity?type=keyword"} className="ms-0">
                <SemButton
                  name={t("common_buttons.activity")}
                  title={t("common_buttons.activity")}
                  icon={<RecentM />}
                />
              </Link>
              {title === "Keyword Overview" &&
              keyword_research_data?.data?.length !== 0 ? (
                <LoadingButton loading={pdfLoader}>
                  <FiDownload
                    className="down"
                    onClick={handlePdfDownload}
                    title="export Keyword Overview as PDF"
                  />
                </LoadingButton>
              ) : null}
            </div>
          </form>

          <p className="heading-medium font-bold vl-msd-line mt-3 ms-1">
          {isPageAccess ? (
            <>
              {valAlert && (
                <p className="heading-medium font-bold vl-msd-line mt-2 ms-1">
                  <span>{valAlert}</span>{" "}
                </p>
              )}
            </>
          ) : (
              <span>{t("dashboard.add_project_buttons.tooltip")}</span>
            )}
            </p>
        </div>
      </div>
      {loading ? <DottLoader /> : <>{children}</>}
    </main>
  );
};

export default KeywordDataProvider;
